
export default {
  components: {
    hotHero: () => import('~/components/Organisms/Hero/Hero.vue'),
    hotContentBlocks: () => import('~/components/Organisms/ContentBlocks/ContentBlocks.vue'),
    hotProducersCarousel: () => import('~/components/Organisms/ProducersCarousel/ProducersCarousel.vue'),
    hotBanner: () => import('~/components/Molecules/Banner/Banner.vue'),
  },
}
